import React from 'react';
import { SourceInfoButton } from '../Components/SourceInfoButton';
import { useStationInfo } from './useStationInfo';

export const StationInfo = ({ stationId }: { stationId: number }) => {
  const { name, path } = useStationInfo(stationId);

  return <SourceInfoButton sourceName={name} sourcePath={path} />;
};
